import { render, staticRenderFns } from "./SurveyEvaluationView.vue?vue&type=template&id=3ed10b78&"
import script from "./SurveyEvaluationView.vue?vue&type=script&lang=ts&"
export * from "./SurveyEvaluationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports